import type z from 'zod/v4'
import { relations } from 'drizzle-orm'
import { pgTable, primaryKey, uuid } from 'drizzle-orm/pg-core'
import { createInsertSchema, createSelectSchema, createUpdateSchema } from 'drizzle-zod'

import { Book } from '../book'
import { BookCollection } from './book-collection'

export const BookCollectionToBook = pgTable(
  'book_collection_to_book',
  {
    bookId: uuid()
      .notNull()
      .references(() => Book.id, { onDelete: 'cascade' }),
    bookCollectionId: uuid()
      .notNull()
      .references(() => BookCollection.id, { onDelete: 'cascade' }),
  },
  (table) => [
    primaryKey({
      columns: [table.bookId, table.bookCollectionId],
      name: 'book_collection_to_book_book_id_book_collection_id_pk',
    }),
  ],
)

export const bookCollectionToBookRelations = relations(BookCollectionToBook, ({ one }) => ({
  book: one(Book, {
    fields: [BookCollectionToBook.bookId],
    references: [Book.id],
  }),

  bookCollection: one(BookCollection, {
    fields: [BookCollectionToBook.bookCollectionId],
    references: [BookCollection.id],
  }),
}))

export const InsertBookCollectionToBookSchema = createInsertSchema(BookCollectionToBook)
export const UpdateBookCollectionToBookSchema = createUpdateSchema(BookCollectionToBook).partial()
export const SelectBookCollectionToBookSchema = createSelectSchema(BookCollectionToBook)

export type InsertBookCollectionToBook = typeof BookCollectionToBook.$inferInsert
export type UpdateBookCollectionToBook = z.infer<typeof UpdateBookCollectionToBookSchema>
export type SelectBookCollectionToBook = typeof BookCollectionToBook.$inferSelect
